export const  CLIENT_CONFIG ={
    CLIENTHQ_FETCH: "CLIENTHQ_FETCH",
    CLIENTHQ_RESET: "CLIENTHQ_RESET",
    CLIENTHQ_SAVE: "CLIENTHQ_SAVE",
};
  